// extracted by mini-css-extract-plugin
export var bodySections = "_9x-8";
export var gray = "_9x-7";
export var green = "_9x-4";
export var iconContainer = "_9x-9";
export var iconWidgetContainer = "_9x-1";
export var phoneIcon = "_9x-2";
export var red = "_9x-5";
export var statusDot = "_9x-3";
export var widgetContainer = "_9x-0";
export var yellow = "_9x-6";